<template>
    <div class="bg-white pa-4 rounded-lg h-100 overflow-y-auto">
        <v-form @submit.prevent="$refs.ticketForm.isValid && sendTicket()" ref="ticketForm">
            <v-col xl="6" lg="7" md="9" class="pa-0 mt-1">
                <v-autocomplete
                    :rules="$validation('required')"
                    :items="this.$system.branches.filter(x => x.status)"
                    item-title="name"
                    item-value="id"
                    label="* شعبه گیرنده"
                    no-data-text="موردی پیدا نشد!"
                    v-model="form.branch_id"
                    @update:modelValue="organization_id = null"
                    v-if="$auth.user.full_admin"
                ></v-autocomplete>
                <v-autocomplete
                    :disabled="(!!$auth.user.full_admin && !form.branch_id)"
                    :items="$auth.user.full_admin ? $system.organizations.filter(x => x.branch_id == form.branch_id) : $system.organizations"
                    item-title="name"
                    item-value="id"
                    label="سازمان مشتریان"
                    no-data-text="موردی پیدا نشد!"
                    clearable
                    v-model="organization_id"
                ></v-autocomplete>
                <v-autocomplete
                    :disabled="!!$auth.user.full_admin && !form.branch_id"
                    :rules="$validation('required')"
                    :items="fromUserList"
                    hide-no-data
                    :loading="inputLoading"
                    @update:search="fromUserInputSearchChange"
                    v-model="form.from_user"
                    hide-selected
                    item-title="name"
                    item-value="id"
                    placeholder="حداقل 3 حرف جستجو کنید"
                    label="* ارسال از طرف"
                ></v-autocomplete>
                <v-autocomplete
                    :rules="$validation('required')"
                    :items="departments"
                    item-title="name"
                    item-value="id"
                    label="* دپارتمان/گروه گیرنده"
                    no-data-text="موردی پیدا نشد!"
                    v-model="form.to_department"
                    :disabled="!form.from_user"
                ></v-autocomplete>
                <v-autocomplete
                    :rules="$validation('required')"
                    :items="serviceList"
                    :disabled="!form.to_department"
                    item-title="name"
                    item-value="id"
                    label="* سرویس‌ها/محصولات"
                    no-data-text="موردی پیدا نشد!"
                    v-model="form.service_id"
                    v-if="serviceList.length"
                ></v-autocomplete>
                <v-autocomplete
                    :rules="$validation('required')"
                    :disabled="!form.to_department"
                    :items="[...categories,{name:'سایر',id:'other',status:true}].filter(x=>x.status)"
                    item-title="name"
                    item-value="id"
                    label="* دسته بندی موضوعی"
                    no-data-text="موردی پیدا نشد!"
                    v-model="form.ticket_category_id"
                ></v-autocomplete>
                <v-slide-y-transition>
                    <div class="pa-2 mb-7 rounded" v-if="form.ticket_category_id && form.ticket_category_id != 'other' && categories.find(x => x.id == form.ticket_category_id).description" style="background-color: #eef7ff; border: 1px solid #2877dc !important">
                        <p class="text-grey-darken-3 text-small">{{ categories.find(x => x.id == form.ticket_category_id).description }}</p>
                    </div>
                </v-slide-y-transition>
                <v-select
                    :rules="$validation('required')"
                    label="* میزان اهمیت"
                    v-model="form.importance"
                    item-title="name"
                    item-value="id"
                    :items="$system.importances"
                    no-data-text="موردی پیدا نشد!"
                ></v-select>
                <v-text-field
                    :rules="$validation('required')"
                    class="my-1"
                    label="* عنوان"
                    v-model="form.title"
                ></v-text-field>
                <custom-fields-form v-model="form.custom_fields" :items="customFields" v-if="$system.license.features.custom_field" transition></custom-fields-form>
                <ckeditor
                    v-model="form.content"
                ></ckeditor>
                <div class="d-flex justify-end bg-blue-grey-lighten-5 border border-t-0 rounded-b pa-1">
                    <v-badge :model-value="$refs.files && !!$refs.files.getFiles()?.length" :content="$refs.files ? $refs.files.getFiles().length : 0" location="top right">
                        <v-btn size="small" class="mx-1" icon variant="text" color="primary" v-tooltip="'فایل‌ پیوست'">
                            <v-icon @click="attachmentDialog = true" color="primary">icon-attachticket</v-icon>
                        </v-btn>
                    </v-badge>
                </div>
                <div class="mt-4">
                    <v-btn type="submit" color="success" :loading="loading">ارسال تیکت</v-btn>
                    <v-btn class="ms-3" variant="text" color="error" @click="$router.push({path: '/tickets'});" :disabled="loading">بازگشت</v-btn>
                </div>
            </v-col>
        </v-form>
        <v-dialog persistent v-model="attachmentDialog" width="500" eager>
            <v-card tile>
                <v-toolbar color="white">
                    <v-toolbar-title class="text-primary">آپلود فایل‌های پیوست</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn @click="attachmentDialog = false" icon>
                        <v-icon color="primary" size="23">close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-divider></v-divider>
                <div class="px-6 py-4 text-grey-darken-2">
                    <p class="text-small text-grey-darken-3 mb-0">فرمت های مجاز فایل های پیوست: {{$system.systemSettings.attachments_allowed_types.map(x => x.toUpperCase()).join(', ')}}</p>
                    <p class="text-small text-grey-darken-3 mb-0 mt-n1">حداکثر حجم تمام فایل های پیوست: {{$system.systemSettings.attachments_maximum_size}}</p>
                    <p class="text-small text-grey-darken-3 mb-0 mt-n1">حداکثر تعداد فایل پیوست: 5 مورد</p>
                    <file-input
                        class="mt-3"
                        :style="{backgroundColor: '#e7e7e7', borderRadius: '4px'}"
                        :text="`<p class='text-meta font-weight-bold text-center mb-0 py-7'>آپلود فایل‌های پیوست</p>`"
                        :types="$system.systemSettings.attachments_allowed_types"
                        :mimeTypes="$system.systemSettings.attachments_allowed_types.map(x => $system.mimeTypes[x]).flat()"
                        :size="parseInt($system.systemSettings.attachments_maximum_size) * ($system.systemSettings.attachments_maximum_size.indexOf('MB') != -1 ? 1048576 : 1024)"
                        :maxFiles="5"
                        type="file"
                        ref="files"
                    ></file-input>
                </div>
                <v-card-actions class="pb-4 mx-2">
                    <v-btn @click="attachmentDialog = false" block variant="flat" color="success" >بستن و ادامه</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
export default {
    title: "ایجاد",
    validate(context) {
        return context.rbac.can('send ticket behalf customers') || !this.$system.license.features.ticket_send_behalf_customer;
    },
    data() {
        return {
            loading: false,
            inputLoading: false,
            fromUserList: [],
            departments: [],
            serviceList: [],
            categories: [],
            customFields: [],
            ticketForm: false,
            form: {
                from_department: this.$system.customers_department.id,
                to_department: null,
                ticket_category_id: null,
                title: null,
                content: '',
                importance: null,
                service_id: null,
                from_user: null,
                custom_fields: [],
                branch_id: null,
            },
            organization_id: null,
            attachmentDialog: false,
        };
    },
    methods: {
        setCustomFields() {
            if (this.$system.license.features.custom_field) {
                let ticketForm = this.$system.ticketForms.find(x => x.status &&
                    x.form.custom_fields.length &&
                    this.form.to_department &&
                    x.department_id == this.form.to_department &&
                    (!x.services.length || (this.form.service_id && x.services.find(y => y.id == this.form.service_id))) &&
                    ((!x.ticket_categories.length && !x.other_ticket_category) ||
                        (x.ticket_categories.length && this.form.ticket_category_id && x.ticket_categories.find(y => y.id == this.form.ticket_category_id)) ||
                        (x.other_ticket_category && this.form.ticket_category_id == 'other'))
                );
                if (ticketForm && (!this.ticketForm || ticketForm.id !== this.ticketForm.id))
                    this.customFields = ticketForm.form.custom_fields;
                else if (!ticketForm && this.ticketForm)
                    this.customFields = [];
                this.ticketForm = ticketForm;
            }
        },
        ticketCategoryChanged() {
            this.setCustomFields();
        },
        serviceChanged() {
            this.setCustomFields();
        },
        organizationChanged() {
            this.form.from_user = null;
            this.fromUserList = [];
            if (this.organization_id && this.$system.organizations.find(x => x.id == this.organization_id)?.customer_informations_count < 51)
                this.fromUserInputSearchChange('organizationChanged');
            if (this.$refs.ticketForm)
                this.$refs.ticketForm.resetValidation();
        },
        fromUserChanged() {
            this.form.to_department = null;
            this.form.service_id = null;
            this.serviceList = [];
            if (this.form.from_user) {
                let fromUser = this.fromUserList.find((x) => x.id == this.form.from_user)
                this.departments = fromUser.to_departments;
                if (fromUser.expired)
                    this.$toast.warning('حساب کاربری ' + fromUser.name + ' غیر فعال یا منقضی شده است');
            } else
                this.departments = [];
        },
        toDepartmentChanged() {
            this.form.service_id = null;
            this.form.ticket_category_id = null;
            this.categories = [];
            this.categories = this.$system.ticketCategories.filter(x => x.department_id === this.form.to_department && x.status);
            this.serviceList = this.departments.find(x=> x.id == this.form.to_department).services
            this.setCustomFields();
        },
        fromUserInputSearchChange(val) {
            if (!this.inputLoading && val && val.length > 2 && this.fromUserList.find(x => x.id == this.form.from_user)?.name !== val) {
                this.inputLoading = true;
                let params = {
                    ticket_keyword: val !== 'organizationChanged' ? val : null,
                    ticketFromUser: 1,
                    fast: 1,
                    employee: 0,
                }
                if(this.organization_id)
                    params['organizations'] = [this.organization_id];
                if (this.$auth.user.full_admin)
                    params["branch_id"] = this.form.branch_id;
                this.$userList(params).then((res) => {
                    if (res && res.status == "OK") {
                        let newUsers = res.data.map(x => {x.name = x.customer_information.position ? `${x.name} (${x.customer_information.position})` : (x.name ?? '-'); delete x.customer_information; return x;});
                        let oldUsers = this.fromUserList.filter(x => this.form.from_user == x.id && !newUsers.some(y => y.id == x.id));
                        this.fromUserList = [...oldUsers, ...newUsers];
                    }
                }).finally(() => this.inputLoading = false);
            }
        },
        sendTicket() {
            if (!this.form.content.replace(/<[^>]*>?/gm, ""))
                this.$toast.error("تکمیل محتوای تیکت الزامی است");
            else {
                this.loading = true
                let form = { ...this.form };
                if (this.$system.license.features.custom_field)
                    form.custom_fields = form.custom_fields.filter(x => x.value !== '' && x.value !== null);
                if (!this.$system.license.features.custom_field || !form.custom_fields.length)
                    delete form.custom_fields;
                form.importance = this.$system.importances[this.form.importance].id; // think about this
                if (!form.service_id)
                    delete form.service_id;
                if (form.ticket_category_id === "other")
                    form.ticket_category_id = null;
                if (this.$refs.files) {
                    let attachments = this.$refs.files.getValidFiles();
                    if(attachments.length)
                        form.attachments = attachments.map(x => x.file);
                }
                this.$ticketStore(this.$object.toFormData(form)).then((res) => {
                    if (res && res.status == "CREATED") {
                        if(Object.hasOwn(res.data, 'in_shift') && !res.data.in_shift)
                            this.$toast.warning(res.message);
                        else
                            this.$toast.success(res.message);
                        this.$router.push({path: '/tickets' });
                    }
                }).finally(()=>{this.loading = false});
            }
        },
        async checkCustomerFromQuery() {
            if (Object.hasOwn(this.$route.query, "customer_id") || Object.hasOwn(this.$route.query, "mobile") || Object.hasOwn(this.$route.query, "email")) {
                let params = {
                    ticketFromUser: 1,
                    fast: 1,
                    employee: 0,
                };
                if (Object.hasOwn(this.$route.query, "customer_id"))
                    params.ids = [this.$route.query.customer_id];
                else {
                    if (Object.hasOwn(this.$route.query, "mobile") && this.$route.query.mobile)
                        params.ticketFromUserMobile = this.$route.query.mobile;
                    if (Object.hasOwn(this.$route.query, "email") && this.$route.query.email)
                        params.ticketFromUserEmail = this.$route.query.email;
                }
                await this.$userList(params).then((res) => {
                    if (res && res.status == "OK" && res.data.length) {
                        if (this.$auth.user.full_admin)
                            this.form.branch_id = res.data[0].branch_id;
                        this.fromUserList = res.data;
                        this.form.from_user = res.data[0].id;
                    }
                });
            }
        },
    },
    watch: {
        attachmentDialog() {
            setTimeout(() => {
                this.attachmentDialog ? this.$refs.files.activePasteEvent() : this.$refs.files.deactivePasteEvent();
            }, 100);
        },
        organization_id() {
            this.organizationChanged();
        },
        "form.ticket_category_id"() {
            this.ticketCategoryChanged();
        },
        "form.service_id"() {
            this.serviceChanged();
        },
        "form.from_user"() {
            this.fromUserChanged();
        },
        "form.to_department"() {
            this.toDepartmentChanged();
        }
    },
    mounted() {
        this.$nextTick(async () => {
            this.$loading.start();
            await this.checkCustomerFromQuery();
            if (this.$auth.user.full_admin && this.$system.branches.filter(x => x.status).length == 1)
                this.form.branch_id = this.$system.branches.filter(x => x.status)[0].id;
            this.$loading.finish();
        });
    },
};
</script>
